import { ExternalLink } from 'lucide-react';
import type { ReactNode } from 'react';

export { formatPrice } from '../../../lib/format-price';

/**
 * Shared building blocks for the trail's per-tool detail. All detail rows are
 * indented (`pl-6`) to line up under the step label, past the step icon.
 */

export function DetailRow({ children }: { children: ReactNode }) {
  return (
    <div className='flex flex-wrap items-center gap-1 pl-6 text-xs text-chat-foreground'>
      {children}
    </div>
  );
}

export function DetailChip({
  icon,
  children,
}: {
  icon?: ReactNode;
  children: ReactNode;
}) {
  return (
    <span className='inline-flex max-w-full items-center gap-1 whitespace-nowrap rounded-full border border-chat-border bg-chat-background-secondary px-1.5 py-0.5 [&_svg]:size-3 [&_svg]:shrink-0'>
      {icon}
      <span className='min-w-0 truncate'>{children}</span>
    </span>
  );
}

export function DetailLinkChip({
  href,
  icon,
  children,
}: {
  href: string;
  icon?: ReactNode;
  children: ReactNode;
}) {
  return (
    <a
      href={href}
      target='_blank'
      rel='noopener noreferrer'
      className='inline-flex max-w-full items-center gap-1 rounded-full border border-chat-border bg-chat-background-secondary px-1.5 py-0.5 hover:underline [&_svg]:size-3 [&_svg]:shrink-0'
    >
      {icon}
      <span className='min-w-0 truncate'>{children}</span>
      <ExternalLink className='opacity-60' />
    </a>
  );
}
